import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  DialogContent,
  DialogActions,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";

import ProcesosApi from "api/procesosApi";
import useParametrosGenerales from "hooks/useParametrosGenerales";

const ProrrogarProceso = ({ open, onClose, audienciaId, audiencia: audienciaProp, onSuccess }) => {
  const [error, setError] = useState(undefined);
  const [audiencia, setAudiencia] = useState(null);
  const [newProrroga, setNewProrroga] = useState({
    manifestaciones: "",
  });
  const [saving, setSaving] = useState(false);
  const { parametros } = useParametrosGenerales();

  const fetchInitialData = async () => {
    try {
      // Si se pasa la audiencia como prop, usarla directamente
      if (audienciaProp) {
        setAudiencia(audienciaProp);
        return;
      }
      // Solo hacer fetch si no se pasa la audiencia como prop
      const audienciaResp = await ProcesosApi.fetchAudienciaById(audienciaId);
      setAudiencia(audienciaResp.data);
    } catch (error) {
      console.error("Error al obtener los datos iniciales:", error);
      setError(obtenerMensajeError(error, "Error al cargar los datos iniciales."));
    }
  };

  useEffect(() => {
    if (open && (audienciaId || audienciaProp)) {
      fetchInitialData();
    }
  }, [audienciaId, audienciaProp, open]);

  // Actualizar audiencia local cuando cambie la prop
  useEffect(() => {
    if (audienciaProp) {
      setAudiencia(audienciaProp);
    }
  }, [audienciaProp]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newProrroga.cantidad_dias) {
      alert("Debe seleccionar una Cantidad de Días de la Prórroga.");
      return;
    }
    if (!newProrroga.observacion) {
      alert("Debe ingresar una Observación de la Prórroga.");
      return;
    }
    const confirmacion = window.confirm(
      `¿Está seguro(a) de que desea registrar una prorrogar al Proceso? Esto aumenta el tiempo de gestión del proceso en la cantidad de dias seleccionados.`
    );
    if (!confirmacion) return;
    try {
      setSaving(true);
      const nuevaProrroga = {
        orden: audiencia.proceso_prorrogas
          ? Object.keys(audiencia.proceso_prorrogas).length + 1
          : 1,
        cantidad_dias: newProrroga.cantidad_dias,
        fecha_creacion: new Date().toISOString(),
        observacion: newProrroga.observacion,
        id_audiencia: audienciaId,
        tipo: "prorroga",
      };
      const prorrogasActualizadas = audiencia.proceso_prorrogas
        ? [...audiencia.proceso_prorrogas, nuevaProrroga]
        : [nuevaProrroga];
      await ProcesosApi.actualizarProceso(audiencia.proceso, {
        prorrogas: prorrogasActualizadas,
      });
      alert("El Proceso ha sido prorrogado correctamente.");
      onSuccess();
    } catch (error) {
      console.error("Error creando la Prórroga:", error);
    } finally {
      setSaving(false);
    }
  };

  const hCClose = () => {
    onClose();
  };

  return (
    <>
      {saving && (
        <Backdrop open={true} style={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Dialog open={open} onClose={hCClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <SuiBox mt={1}>
            <strong>
              Prorrogar el Proceso: {audiencia?.proceso_identificador || "No tiene Proceso"}
            </strong>
          </SuiBox>
        </DialogTitle>
        <DialogContent>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Cantidad de Días
              </SuiTypography>
              <Select
                value={newProrroga.cantidad_dias}
                onChange={(e) => setNewProrroga({ ...newProrroga, cantidad_dias: e.target.value })}
                displayEmpty
                fullWidth
              >
                {parametros.DIAS_PRORROGA_OPCIONES.map((dias) => (
                  <MenuItem key={dias} value={String(dias)}>
                    {dias} días
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <SuiTypography variant="h6" fontWeight="light">
                Observación de la Prórroga
              </SuiTypography>
              <SuiInput
                name="observacion"
                multiline
                rows={4}
                value={newProrroga.observacion}
                onChange={(e) => setNewProrroga({ ...newProrroga, observacion: e.target.value })}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} color="secondary">
            Cancelar
          </SuiButton>
          <SuiButton variant="gradient" buttonColor="dark" onClick={handleSubmit}>
            Revocar
          </SuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

ProrrogarProceso.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  audienciaId: PropTypes.int,
  audiencia: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default ProrrogarProceso;
